import { createAsyncThunk } from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
import { TRAFFIC_FINE_SERVICE } from '../EndPoints';

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

export const GetUserTrafficDetails = createAsyncThunk(
    'traffic/GetUserTrafficDetails ',
    async (userId, { dispatch, getState }) => {
        const response = await apiInstance
            .get(`${TRAFFIC_FINE_SERVICE.getUserTrafficDetails}${userId}`)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);

export const GetFinesTrafficDetails = createAsyncThunk(
    'traffic/GetFinesTrafficDetails',
    async (fineId, { dispatch, getState }) => {
        const response = await apiInstance
            .get(`${TRAFFIC_FINE_SERVICE.getFinesTrafficDetails}${fineId}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = response;

        return { data, status };
    },
);
export const GetEvidencesList = createAsyncThunk('traffic/GetEvidencesList', async (fineId, { dispatch, getState }) => {
    const response = await apiInstance
        .get(`${TRAFFIC_FINE_SERVICE.getEvidencesList}${fineId}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = response;

    return { data, status };
});
export const GetAllGeofenceList = createAsyncThunk('traffic/GetAllGeofenceList ', async () => {
      const result = await apiInstance
        .get(TRAFFIC_FINE_SERVICE.getAllGeofenceList)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const RegisterFinePaid = createAsyncThunk("traffic/RegisterFinePaid",async (params, { dispatch, getState }) => {

    const response = await apiInstance.put(TRAFFIC_FINE_SERVICE.registerFinePaid, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const CreatePaymentEvidence = createAsyncThunk("traffic/CreatePaymentEvidence",async (params, { dispatch, getState }) => {

    const response = await apiInstance.post(TRAFFIC_FINE_SERVICE.createPaymentEvidence, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const GetPaymentEvidence = createAsyncThunk("traffic/GetPaymentEvidence",async (params, { dispatch, getState }) => {

    const response = await apiInstance.get(`${TRAFFIC_FINE_SERVICE.getPaymentEvidence}${params}`).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

